import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { CalendarDays, Menu, X } from "lucide-react";
import { SITE } from "@/config";
import { SocialBubbles } from "@/components/SocialLinks";

export const Header = () => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: "/", label: "Accueil" },
    { to: "/planning", label: "Planning" },
    { to: "/#tarifs", label: "Tarifs" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <header
      className={`sticky top-0 z-50 border-b border-border transition-colors duration-200 ${
        scrolled ? "bg-background/90 backdrop-blur-md" : "bg-background"
      }`}
      data-testid="app-header"
    >
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center gap-3">
            <Link to="/" className="flex items-center gap-2.5" data-testid="header-logo">
              <img
                src="/logo-fenek-head.jpg"
                alt="Logo FNK STUDIO"
                className="h-9 w-9 rounded-md border border-primary/40 object-cover"
              />
              <span className="font-heading text-base font-semibold tracking-tight sm:text-lg">
                {SITE.brandFirst} <span className="text-primary">{SITE.brandSecond}</span>
              </span>
            </Link>
            <SocialBubbles className="hidden sm:flex" />
          </div>

          <nav className="hidden items-center gap-6 md:flex">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium transition-colors hover:text-primary ${
                  location.pathname === link.to ? "text-primary" : "text-muted-foreground"
                }`}
                data-testid={`nav-link-${link.label.toLowerCase()}`}
              >
                {link.label}
              </Link>
            ))}
            <Button asChild data-testid="header-booking-cta">
              <Link to="/reserver">
                <CalendarDays className="mr-2 h-4 w-4" />
                Réserver un créneau
              </Link>
            </Button>
          </nav>

          <button
            className="flex h-10 w-10 items-center justify-center rounded-md border border-border md:hidden"
            onClick={() => setMobileOpen(!mobileOpen)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {mobileOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>

        {mobileOpen && (
          <div className="border-t border-border pb-4 pt-2 md:hidden" data-testid="mobile-menu">
            <div className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="rounded-md px-3 py-2.5 text-sm font-medium text-muted-foreground hover:bg-secondary hover:text-foreground"
                >
                  {link.label}
                </Link>
              ))}
              <div className="px-3 py-2">
                <SocialBubbles />
              </div>
              <Button asChild className="mt-2" data-testid="mobile-booking-cta">
                <Link to="/reserver">
                  <CalendarDays className="mr-2 h-4 w-4" />
                  Réserver un créneau
                </Link>
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};
